import { Component, OnDestroy, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { environment } from 'src/environments/environment';

import { Document } from 'src/app/shared/document';

@Component({
  selector: 'app-edit-document-conditions',
  templateUrl: './edit-document-conditions.component.html',
  styleUrls: ['./edit-document-conditions.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class EditDocumentConditionsComponent implements OnInit, OnChanges, OnDestroy  {

  @Input() document: Document;

  deliveryConditions: string[] = [
    'Отгрузка и оплата',
    'Предоплата',
    'Отсрочка',
    'Доставка до склада',
    'Самовывоз',
    'Опция 3',
    'Опция 100',
  ];

  deliveryConditionsResult: string[] = [];
  suggestDeliveryConditions: string[] = [];

  @Input() docDelvConds: string = 'Общие условия поставки';
  @Input() docDelvTerms: string = 'Срок выполнения (поставки)';
  @Input() docNoteText1: string = 'Примечание для продавца';
  @Input() docNoteText2: string = 'Примечание для покупателя';


  /*
   * Умови оплати
Відвантаження товару
Відвантаження замовлення після отримання 100% оплати
Відвантаження замовлення після отримання передоплати
Відтермінування платежу
Замовлення товару
Розміщення замовлення після отримання 100% передоплати
Розміщення замовлення після отримання передоплати

Вітермінування платежу ______днів



Умови доставки
Доставка поштової/транспортної компанією за рахунок покупця
Доставка поштової/транспортної компанією за рахунок постачальника
Доставка транспортом постачальника
Самовивіз


Очікованний термін виконаня замовлення:_______днів
   */

  @Input() docOptText1: string = 'Оплата';
  @Input() options1: string[] = [
    'Повна попередня оплата',
    'Часткова попередня оплата %, розрахунок протягом % днів',
    'Часткова попередня оплата %, розрахунок по готовності товару',
    'Оплата після поставки протягом % днів',
  ];

  @Input() selected1: string = 'Повна попередня оплата';

  @Input() docOptText2: string = 'Отгрузка/Заказ';
  @Input() options2: string[] = [
    'Відвантаження зі складу',
    'Постачання під замовлення',
  ];

  @Input() selected2: string = 'Відвантаження зі складу';

  @Input() docOptText3: string = 'Доставка';

  @Input() options3: string[] = [
    'Доставка поштової/транспортної компанією за рахунок покупця',
    'Доставка поштової/транспортної компанією за рахунок постачальника',
    'Доставка транспортом постачальника',
    'Самовивіз',
  ];

  @Input() selected3: string = 'Доставка поштової/транспортної компанією за рахунок покупця';

  constructor() { }

  ngOnChanges(changes: SimpleChanges) {
    //console.log('*** EditDocumentConditionsComponent ngOnChanges:');
    for (let propName in changes) {
      let change = changes[propName];

      console.log('*** EditDocumentConditionsComponent ngOnChanges ' + propName + ' (actual): ' + JSON.stringify(change.currentValue));
      //console.log('*** EditDocumentConditionsComponent ngOnChanges ' + propName + ' (was):    ' + JSON.stringify(change.previousValue));

      switch (propName) {

        case 'document':
          if (change.currentValue) {
            this.deliveryConditionsResult.push(change.currentValue.DOCDLVBASE);
          }
          break;
      }
    }
  }

  ngOnDestroy(): void {
    console.log('*** EditDocumentConditionsComponent in ngOnDestroy');

  }

  ngOnInit(): void {
    console.log('*** EditDocumentConditionsComponent in ngOnInit');
  }

  searchDeliveryOptions(event) {
    console.log('*** EditDocumentConditionsComponent searchDeliveryOptions  ' + JSON.stringify(event));

    this.suggestDeliveryConditions = this.deliveryConditions.filter(e => e.includes(event.query)) || [];
  }

  onSelectDeliveryOptions(event) {
    console.log('*** EditDocumentConditionsComponent onSelectDeliveryOptions  ' + JSON.stringify(event));
    environment.production || console.table(this.deliveryConditionsResult);

    if (this.deliveryConditionsResult) {
      this.document.DOCDLVBASE = '';
      this.deliveryConditionsResult.forEach(e => { this.document.DOCDLVBASE += ', ' + e; });
      //console.log(this.document.DOCDLVBASE);
    }
  }

  onUnselectDeliveryOptions(event) {
    console.log('*** EditDocumentConditionsComponent onUnselectDeliveryOptions  ' + JSON.stringify(event));
    environment.production || console.table(this.deliveryConditionsResult);

    if (this.deliveryConditionsResult) {
      this.document.DOCDLVBASE = '';
      this.deliveryConditionsResult.forEach(e => { this.document.DOCDLVBASE += ', ' + e; })
      //console.log(this.document.DOCDLVBASE);
    }
  }

  onDropdownClickDeliveryOptions(event) {
    console.log('*** EditDocumentConditionsComponent onDropdownClickDeliveryOptions  ' + JSON.stringify(event));
    this.suggestDeliveryConditions = [... this.deliveryConditions];
    environment.production || console.table(this.deliveryConditionsResult);
    //this.document.DOCDLVBASE = '';
    //this.deliveryConditionsResult.forEach(e => { this.document.DOCDLVBASE += ', ' + e; })
    //console.log(this.document.DOCDLVBASE);
  }

  onClearDeliveryOptions(event) {
    console.log('*** EditDocumentConditionsComponent onClearDeliveryOptions  ' + JSON.stringify(event));
    environment.production || console.table(this.deliveryConditionsResult);

    if (this.deliveryConditionsResult) {
      this.document.DOCDLVBASE = '';
      this.deliveryConditionsResult.forEach(e => { this.document.DOCDLVBASE += ', ' + e; })
      //console.log(this.document.DOCDLVBASE);
    }
  }

  onFillDeliveryConditions(event) {
    console.log('*** EditDocumentConditionsComponent onFillDeliveryConditions  ' + JSON.stringify(event));

    this.document.DOCDLVBASE = this.selected1 + ', ' + this.selected2 + ', ' + this.selected3
  }

}
